import DocumentSearchBill from "./DocumentSearchBill";

export default DocumentSearchBill;
